module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_ShouShou.0074.png.24885c52.jpg";